import * as actions from "../actions/Type";
const intialState = {
  list_salary: {},
  total_money_branch: 0,
  list_branch_masrufat: [],
  total_masruf_branch: {},
  branch_obj: {},
  // exp states
  create_exp: {},
  list_expenses: [],
  view_exp: {},
  view_masrufat: {},
};
const AccountReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.ADD_TODO_APP:
      return {
        ...state,
        add_todo: action.payload,
      };
    case actions.GET_TOTAL_SALARY_BRANCH:
      return {
        ...state,
        total_money_branch: action.payload,
      };
    case actions.GET_BRANCH_MASRUFAT:
      return {
        ...state,
        list_branch_masrufat: action.payload,
        branch_obj: action.branch_obj,
      };
    case actions.GET_TOTAL_BRANCH_MASRUFAT:
      return {
        ...state,
        total_masruf_branch: action.payload,
      };
    // exp reducer
    case actions.EXP_CREATE:
      return {
        ...state,
        create_exp: action.payload,
        list_expenses: [action.payload, ...state.list_expenses],
      };
    case actions.EXP_LIST:
      return {
        ...state,
        list_expenses: action.payload,
      };
    case actions.EXP_DELETE:
      return {
        ...state,
        list_expenses: state.list_expenses.filter(
          (el) => el._id !== action.ex_id
        ),
      };
    case actions.EXP_UPDATE:
      return {
        ...state,
      };
    case actions.EXP_VIEW:
      return {
        ...state,
        view_exp: action.payload,
      };
    case actions.MASRUFAT_UPDATE:
      return {
        ...state,
      };
    case actions.MASRUFAT_VIEW:
      return {
        ...state,
        view_masrufat: action.payload,
      };
    default:
      return { ...state };
  }
};

export default AccountReducer;
